"use client"
import { useConnectWallet, useWallets } from "@privy-io/react-auth"
import { Button } from "@/components/ui/button"
import Spinner from "@/components/Spinner"

export default function ConnectWalletButton(props: {
  className?: string
  variant?: "default" | "outline" | "secondary" | "ghost" | "link"
}) {
  const { wallets, ready } = useWallets()
  const { connectWallet } = useConnectWallet()

  // Determine button text based on connection and verification status
  const buttonText =
    wallets.length !== 0 ? wallets[0].address : "Connect wallet"

  return (
    <Button
      type="button"
      onClick={(ev) => {
        ev.preventDefault()
        if (wallets.length !== 0) return

        connectWallet()
      }}
      disabled={!ready}
      className={props.className}
      variant={props.variant}
    >
      {ready ? buttonText : <Spinner width={4} height={4} />}
    </Button>
  )
}
